import React, { useState, useEffect, useMemo, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MainContainer from "../../../components/MainContainer";
import { Grid, Button } from "@material-ui/core";
import { headerData } from '../../../data/modules/dashboard-header';
import { LoadingButton } from '@mui/lab';
import SearchIcon from '@mui/icons-material/Search';
import PlanningMissionService from "../../../services/PlanningMissionService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import LocalisationMisService from "../../../services/LocalisationMisService";
import { Chip } from "@material-ui/core";
import MissionService from "../../../services/MissionService";
import LoadingTexteBackdrop from "../../tools/LoadingTexteBackdrop";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import Title from "../../../components/Title";
import Spacer from '../../../components/Spacer';
import { 
  Visibility as VisibilityIcon, 
  TrendingUp as TrendingUpIcon,
  Download as DownloadIcon,
  FileDownload as FileDownloadIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  FilterList as FilterListIcon
} from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Avatar,
  Tooltip,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  textField: {
    float: 'rigth',
    width: '20%',
  },
  select: {
    width: '20%',
  },
  topFiveCard: {
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
    }
  },
  topFiveTitle: {
    color: '#1976d2',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  exportButton: {
    backgroundColor: '#4caf50',
    color: 'white',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
    marginRight: theme.spacing(1),
  },
  headerWithExport: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  filterButton: {
    marginLeft: theme.spacing(1),
  },
  sortableHeader: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e3f2fd',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  clickableChip: {
    cursor: 'pointer',
    transition: 'transform 0.1s',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    }
  }
}));

/**
 * Fonction utilitaire pour appeler une méthode du service en toute sécurité.
 * Essaie plusieurs noms de méthodes possibles et retourne une promesse résolue
 * avec un tableau vide si aucune méthode n'est trouvée.
 */
const safeCall = (service, methodNames, ...args) => {
  if (!service) return Promise.resolve({ data: [] });
  
  for (const name of methodNames) {
    if (typeof service[name] === 'function') {
      try {
        const result = service[name](...args);
        // Si c'est déjà une promesse, la retourner
        if (result && typeof result.then === 'function') {
          return result.catch((err) => {
            console.warn(`Erreur lors de l'appel à ${name}:`, err);
            return { data: [] };
          });
        }
        // Sinon, envelopper dans une promesse
        return Promise.resolve(result);
      } catch (err) {
        console.warn(`Erreur lors de l'appel à ${name}:`, err);
      }
    }
  }
  
  console.warn(`Aucune méthode trouvée parmi: ${methodNames.join(', ')}`);
  return Promise.resolve({ data: [] });
};

export default function StatistiqueAgenda() {
  const classes = useStyles();
  const [isLoading, setIsloading] = useState(false);
  const [direction, setDirection] = useState([]);
  const [region, setRegion] = useState([]);
  const [district, setDistrict] = useState([]);
  const [commune, setCommune] = useState([]);
  const [listedetail, setListedetail] = useState([]);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [typeactivite, setTypeactivite] = useState([]);
  const [financement, setFinancement] = useState([]);
  
  // État pour la pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // État pour la modal de détails
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  // État pour le tri
  const [sortConfig, setSortConfig] = useState({
    key: 'missions',
    direction: 'desc'
  });

  // État pour le menu de tri
  const [sortMenuAnchor, setSortMenuAnchor] = useState(null);

  const [filter, setFilter] = useState({
    date_debut: null,
    date_fin: null,
    directiondest: null,
    directionmiss: null,
    servicemiss: null,
    region: null,
    district: null,
    commune: null,
    group: { value: "directionmiss", label: "Direction de missionnaire" },
    pivot: null,
    typeactivite: null,
    financement: null
  });

  // Fonction de tri
  const sortData = (data, key, direction) => {
    return [...data].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      if (aValue === null || aValue === undefined) aValue = 0;
      if (bValue === null || bValue === undefined) bValue = 0;

      if (key === 'libelle_fr' || key === 'libelle' || key === 'nom') {
        aValue = (a.libelle_fr || a.libelle || a.nom || '').toLowerCase();
        bValue = (b.libelle_fr || b.libelle || b.nom || '').toLowerCase();
      }

      if (aValue < bValue) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  // Données triées
  const sortedData = useMemo(() => {
    return sortData(listedetail, sortConfig.key, sortConfig.direction);
  }, [listedetail, sortConfig]);

  // Top 5 des activités
  const topFiveData = useMemo(() => {
    return sortedData
      .filter(item => item.missions > 0)
      .slice(0, 5);
  }, [sortedData]);

  // Données paginées
  const paginatedData = useMemo(() => {
    return sortedData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [sortedData, page, rowsPerPage]);

  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key: key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
    setPage(0);
  };

  const handleSortMenuOpen = (event) => {
    setSortMenuAnchor(event.currentTarget);
  };

  const handleSortMenuClose = () => {
    setSortMenuAnchor(null);
  };

  const handleSortMenuItemClick = (key, direction) => {
    setSortConfig({ key, direction });
    setPage(0);
    handleSortMenuClose();
  };

  const handleShowDetails = (item) => {
    setSelectedRow(item);
    setOpenDialog(true);
  };

  // Export du tableau principal
  const exportMainTableToExcel = () => {
    try {
      const exportData = sortedData.map((item, index) => ({
        'N°': index + 1,
        'Activité': item.libelle_fr || item.libelle || item.nom || '',
        'Nombre de missions': item.missions || 0
      }));

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);
      ws['!cols'] = [{ wch: 5 }, { wch: 80 }, { wch: 20 }];
      XLSX.utils.book_append_sheet(wb, ws, "Statistiques activités");

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
      const fileName = `statistiques_activites_${new Date().toISOString().split('T')[0]}.xlsx`;
      saveAs(data, fileName);
    } catch (error) {
      console.error("Erreur lors de l'export Excel:", error);
      alert("Erreur lors de l'export du fichier Excel");
    }
  };

  // Export des détails d'une activité
  const exportDetailsToExcel = (activity) => {
    try {
      if (!activity || !activity.details || activity.details.length === 0) {
        alert("Aucun détail à exporter pour cette activité");
        return;
      }

      const exportData = activity.details.map((detail, index) => ({
        'N°': index + 1,
        'Référence': detail.reference || '-',
        'Titre de la mission': detail.mission_title || '-',
        'Date début': detail.date_debut || '-',
        'Date fin': detail.date_fin || '-',
        'Direction': detail.direction || '-',
        'Service': detail.service || '-'
      }));

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);
      ws['!cols'] = [
        { wch: 5 }, { wch: 15 }, { wch: 80 }, { wch: 12 }, { wch: 12 }, { wch: 20 }, { wch: 20 }
      ];
      const sheetName = (activity.libelle_fr || activity.libelle || activity.nom || 'Activité').substring(0, 25);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
      const fileName = `details_${(activity.libelle_fr || activity.libelle || 'activite').substring(0, 30)}_${new Date().toISOString().split('T')[0]}.xlsx`;
      saveAs(data, fileName);
    } catch (error) {
      console.error("Erreur lors de l'export Excel des détails:", error);
      alert("Erreur lors de l'export du fichier Excel");
    }
  };

  // Export complet
  const exportAllWithDetailsToExcel = () => {
    try {
      if (sortedData.length === 0) {
        alert("Aucune donnée à exporter");
        return;
      }

      const wb = XLSX.utils.book_new();

      const summaryData = sortedData.map((item, index) => ({
        'N°': index + 1,
        'Activité': item.libelle_fr || item.libelle || item.nom || '',
        'Nombre de missions': item.missions || 0
      }));

      const wsSummary = XLSX.utils.json_to_sheet(summaryData);
      wsSummary['!cols'] = [{ wch: 5 }, { wch: 80 }, { wch: 20 }];
      XLSX.utils.book_append_sheet(wb, wsSummary, "Résumé activités");

      sortedData.forEach((activity, actIndex) => {
        if (activity.details && activity.details.length > 0) {
          const detailsData = activity.details.map((detail, index) => ({
            'N°': index + 1,
            'Référence': detail.reference || '-',
            'Titre de la mission': detail.mission_title || '-',
            'Date début': detail.date_debut || '-',
            'Date fin': detail.date_fin || '-',
            'Direction': detail.direction || '-',
            'Service': detail.service || '-'
          }));

          const wsDetails = XLSX.utils.json_to_sheet(detailsData);
          wsDetails['!cols'] = [
            { wch: 5 }, { wch: 15 }, { wch: 80 }, { wch: 12 }, { wch: 12 }, { wch: 20 }, { wch: 20 }
          ];

          const sheetName = `Activité ${actIndex + 1}`;
          XLSX.utils.book_append_sheet(wb, wsDetails, sheetName);
        }
      });

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
      const fileName = `statistiques_completes_${new Date().toISOString().split('T')[0]}.xlsx`;
      saveAs(data, fileName);
    } catch (error) {
      console.error("Erreur lors de l'export Excel complet:", error);
      alert("Erreur lors de l'export du fichier Excel");
    }
  };

  function handleChange(event) {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  function handleViewDetails(row) {
    setSelectedRow(row);
    setOpenDialog(true);
  }

  function handleCloseDialog() {
    setOpenDialog(false);
    setSelectedRow(null);
  }

  function handleChangeType(event, value) {
    setFilter({ 
      ...filter, 
      typeactivite: value
    });
  }

  function handleChangeFinancement(event, value) {
    setFilter({ 
      ...filter, 
      financement: value
    });
  }

  function handleChangeRegion(event, value) {
    setFilter({ 
      ...filter, 
      region: value,
      district: null,
      commune: null
    });
    
    if (value && value.id_region) {
      // Essayer plusieurs noms de méthodes
      safeCall(LocalisationMisService, 
        ['getDistrictByRegion', 'getDistrictByRegionId', 'districtByRegion'],
        value.id_region
      ).then((result) => {
        if (result && result.data) {
          setDistrict(result.data);
        }
      });
    } else {
      // Charger tous les districts
      safeCall(LocalisationMisService, 
        ['alldistrict', 'getAlldistrict', 'getAllDistrict', 'getDistricts', 'listeDistrict', 'listDistrict']
      ).then((result) => {
        if (result && result.data) {
          setDistrict(result.data);
        }
      });
    }
  }

  function handleChangeDistrict(event, value) {
    setFilter({ 
      ...filter, 
      district: value,
      commune: null
    });
    
    if (value && value.id_district) {
      safeCall(LocalisationMisService,
        ['getCommune', 'getCommuneByDistrict', 'communeByDistrict'],
        value.id_district
      ).then((result) => {
        if (result && result.data) {
          setCommune(result.data);
        }
      });
    } else {
      safeCall(LocalisationMisService,
        ['allcommune', 'getAllcommune', 'getAllCommune', 'getCommunes', 'listeCommune', 'listCommune']
      ).then((result) => {
        if (result && result.data) {
          setCommune(result.data);
        }
      });
    }
  }

  function handleChangeCommune(event, value) {
    setFilter(prevFilter => ({
      ...prevFilter,
      commune: value
    }));

    if (value) {
      if (value.id_region && value.id_district) {
        const selectedRegion = region.find(r => r.id_region === value.id_region);
        const selectedDistrict = district.find(d => d.id_district === value.id_district);
        
        setFilter(prevFilter => ({
          ...prevFilter,
          region: selectedRegion || prevFilter.region,
          district: selectedDistrict || prevFilter.district,
          commune: value
        }));
      }
    }
  }

  function handleFilter() {
    setOpenLoadingSimpleBackdrop(true);
    setPage(0);

    const regionId = filter?.region?.id_region ?? "null";
    const districtId = filter?.district?.id_district ?? "null";
    const communeId = filter?.commune?.id_commune ?? "null";
    const typeId = filter?.typeactivite?.id_type_activite ?? "null";
    const financementId = filter?.financement?.id_financement ?? "null";

    Promise.all([
      safeCall(LocalisationMisService,
        ['getactivitelist', 'getActiviteList', 'activitelist'],
        regionId, districtId, communeId, typeId, financementId
      ),
      MissionService.detailgrapheagenda(
        filter.date_debut,
        filter.date_fin,
        filter.directionmiss,
        filter.servicemiss,
        filter.directiondest,
        filter.region,
        filter.district,
        filter.group,
        filter.pivot
      )
    ]).then(([activitesResult, agendaResult]) => {
      
      
      if (activitesResult?.data && agendaResult?.data) {
        
        const agendaMap = new Map();

        agendaResult.data.forEach(item => {
          const key = item.direction?.toString();
          agendaMap.set(key, {
            missions: item.missions,
            details: item.details || []
          });
        });

        const table = activitesResult.data.map(activite => {
          const activiteLibelle = (activite.libelle_fr)?.toString();
          const agendaData = agendaMap.get(activiteLibelle) || { missions: 0, details: [] };
          
          return {
            ...activite,
            missions: agendaData.missions,
            details: agendaData.details
          };
        });
        
        setListedetail(table);
      } else {
        setListedetail([]);
      }
      
    }).catch((error) => {
      console.error("Erreur lors du filtrage:", error);
      setListedetail([]);
    }).finally(() => {
      setOpenLoadingSimpleBackdrop(false);
    });
  }

  function handleReset() {
    setFilter({
      date_debut: null,
      date_fin: null,
      directiondest: null,
      directionmiss: null,
      servicemiss: null,
      region: null,
      district: null,
      commune: null,
      group: { value: "directionmiss", label: "Direction de missionnaire" },
      pivot: null,
      typeactivite: null,
      financement: null
    });
    setDistrict([]);
    setCommune([]);
    setListedetail([]);
    setPage(0);
    
    safeCall(LocalisationMisService,
      ['alldistrict', 'getAlldistrict', 'getAllDistrict', 'getDistricts', 'listeDistrict', 'listDistrict']
    ).then((result) => {
      if (result && result.data) {
        setDistrict(result.data);
      }
    });
    
    safeCall(LocalisationMisService,
      ['allcommune', 'getAllcommune', 'getAllCommune', 'getCommunes', 'listeCommune', 'listCommune']
    ).then((result) => {
      if (result && result.data) {
        setCommune(result.data);
      }
    });
  }

  useEffect(() => {
    // Charger les régions
    safeCall(LocalisationMisService,
      ['getRegions', 'getAllRegions', 'listeRegion', 'listRegion']
    ).then((result) => {
      if (result && result.data) {
        setRegion(result.data);
      }
    });

    // Charger les districts
    safeCall(LocalisationMisService,
      ['alldistrict', 'getAlldistrict', 'getAllDistrict', 'getDistricts', 'listeDistrict', 'listDistrict']
    ).then((result) => {
      if (result && result.data) {
        setDistrict(result.data);
      }
    });

    // Charger les communes
    safeCall(LocalisationMisService,
      ['allcommune', 'getAllcommune', 'getAllCommune', 'getCommunes', 'listeCommune', 'listCommune']
    ).then((result) => {
      if (result && result.data) {
        setCommune(result.data);
      }
    });

    // Charger les types d'activité
    safeCall(LocalisationMisService,
      ['typeactivite', 'getTypeActivite', 'getTypeActivites', 'listeTypeActivite']
    ).then((result) => {
      if (result && result.data) {
        setTypeactivite(result.data);
      }
    });

    // Charger les financements
    safeCall(LocalisationMisService,
      ['listFinancement', 'getFinancement', 'getFinancements', 'listeFinancement']
    ).then((result) => {
      if (result && result.data) {
        setFinancement(result.data);
      }
    });
  }, []);

  return (
    <MainContainer {...headerData}>
      <LoadingTexteBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <React.Fragment>
        <Grid container spacing={4}>
          <Grid item xs={2}>
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={handleFilter}
              loading={isLoading}
              style={{
                fontWeight: 600,
                width: "100%",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              startIcon={<SearchIcon style={{ marginRight: '8px' }} />}
            >
              Filtrer
            </LoadingButton>
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleReset}
              style={{
                fontWeight: 600,
                width: "100%"
              }}
            >
              Réinitialiser
            </Button>
          </Grid>
          <Grid item xs={8}></Grid>

          {/* Filtres */}
          <Grid item xs={4}>
            Date début:
            <TextField
              fullWidth
              id="date_debut"
              size="small"
              variant="outlined"
              type="date"
              value={filter.date_debut || ''}
              name="date_debut"
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={4}>
            Region :
            <Autocomplete
              onChange={handleChangeRegion}
              options={region}
              getOptionLabel={(option) => option?.nom_region || ""}
              value={filter.region}
              isOptionEqualToValue={(option, value) => 
                option?.id_region === value?.id_region
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Région"
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            Type d'activité :
            <Autocomplete
              onChange={handleChangeType}
              options={typeactivite}
              getOptionLabel={(option) => option?.libelle_type_activite || ""}
              value={filter.typeactivite}
              isOptionEqualToValue={(option, value) => 
                option?.id_type_activite === value?.id_type_activite
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Type d'activité"
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          
          <Grid item xs={4}>
            Date fin:
            <TextField
              fullWidth
              id="date_fin"
              size="small"
              variant="outlined"
              type="date"
              value={filter.date_fin || ''}
              name="date_fin"
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={4}>
            District :
            <Autocomplete
              onChange={handleChangeDistrict}
              options={district}
              getOptionLabel={(option) => option?.nom_district || ""}
              value={filter.district}
              isOptionEqualToValue={(option, value) => 
                option?.id_district === value?.id_district
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="District"
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            Financement :
            <Autocomplete
              onChange={handleChangeFinancement}
              options={financement}
              getOptionLabel={(option) => option?.code_financement || ""}
              value={filter.financement}
              isOptionEqualToValue={(option, value) => 
                option?.id_financement === value?.id_financement
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Financement"
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          
          <Grid item xs={4}></Grid>
          <Grid item xs={4}>
            Commune :
            <Autocomplete
              onChange={handleChangeCommune}
              options={commune}
              getOptionLabel={(option) => option?.nom_commune || ""}
              value={filter.commune}
              isOptionEqualToValue={(option, value) => 
                option?.id_commune === value?.id_commune
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Commune"
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Spacer height={2} />
          </Grid>

          {topFiveData.length > 0 && (
            <Grid item xs={12}>
              <Card className={classes.topFiveCard} onClick={() => handleShowDetails(topFiveData[0])}>
                <CardContent>
                  <Typography variant="h6" className={classes.topFiveTitle}>
                    <TrendingUpIcon /> Top 5 des activités 
                  </Typography>
                  <Spacer height={2} />
                  <List>
                    {topFiveData.map((item, index) => (
                      <React.Fragment key={index}>
                        <ListItem 
                          alignItems="flex-start"
                          button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleShowDetails(item);
                          }}
                        >
                          <ListItemIcon>
                            <Avatar 
                              sx={{ 
                                bgcolor: index === 0 ? '#4caf50' : 
                                        index === 1 ? '#2196f3' : 
                                        index === 2 ? '#ff9800' : '#9e9e9e',
                                width: 32,
                                height: 32
                              }}
                            >
                              {index + 1}
                            </Avatar>
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <Typography variant="subtitle2" noWrap style={{ maxWidth: '500px' }}>
                                  {item.libelle_fr || item.libelle || item.nom}
                                </Typography>
                                <Chip 
                                  label={`${item.missions} mission${item.missions > 1 ? 's' : ''}`}
                                  color="primary"
                                  size="small"
                                  className={classes.clickableChip}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleShowDetails(item);
                                  }}
                                  sx={{ ml: 2 }}
                                />
                              </Box>
                            }
                          />
                        </ListItem>
                        {index < 4 && <Divider variant="inset" component="li" />}
                      </React.Fragment>
                    ))}
                  </List>
                </CardContent>
              </Card>
              <Spacer height={3} />
            </Grid>
          )}

          <Grid item xs={12}>
            <Box className={classes.headerWithExport}>
              <Typography variant="h6">
                Liste des activités
              </Typography>
              <Box>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<FilterListIcon />}
                  onClick={handleSortMenuOpen}
                  className={classes.filterButton}
                  sx={{ mr: 1 }}
                >
                  Trier ({sortConfig.key === 'missions' ? 'Nb missions' : 'Activité'} {sortConfig.direction === 'asc' ? '↑' : '↓'})
                </Button>

                <Menu
                  anchorEl={sortMenuAnchor}
                  open={Boolean(sortMenuAnchor)}
                  onClose={handleSortMenuClose}
                >
                  <MenuItem disabled>
                    <Typography variant="subtitle2" color="textSecondary">
                      Trier par:
                    </Typography>
                  </MenuItem>
                  <MenuItem onClick={() => handleSortMenuItemClick('missions', 'desc')}>
                    <ListItemIcon>
                      <ArrowDownwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Nombre de missions (décroissant)</ListItemText>
                    {sortConfig.key === 'missions' && sortConfig.direction === 'desc' && ' ✓'}
                  </MenuItem>
                  <MenuItem onClick={() => handleSortMenuItemClick('missions', 'asc')}>
                    <ListItemIcon>
                      <ArrowUpwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Nombre de missions (croissant)</ListItemText>
                    {sortConfig.key === 'missions' && sortConfig.direction === 'asc' && ' ✓'}
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={() => handleSortMenuItemClick('libelle_fr', 'asc')}>
                    <ListItemIcon>
                      <ArrowUpwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Activité (A → Z)</ListItemText>
                    {sortConfig.key === 'libelle_fr' && sortConfig.direction === 'asc' && ' ✓'}
                  </MenuItem>
                  <MenuItem onClick={() => handleSortMenuItemClick('libelle_fr', 'desc')}>
                    <ListItemIcon>
                      <ArrowDownwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Activité (Z → A)</ListItemText>
                    {sortConfig.key === 'libelle_fr' && sortConfig.direction === 'desc' && ' ✓'}
                  </MenuItem>
                </Menu>

                <Tooltip title="Exporter le tableau principal">
                  <Button
                    variant="contained"
                    className={classes.exportButton}
                    startIcon={<FileDownloadIcon />}
                    onClick={exportMainTableToExcel}
                    size="small"
                    sx={{ mr: 1 }}
                    disabled={sortedData.length === 0}
                  >
                    Export excel
                  </Button>
                </Tooltip>
                <Tooltip title="Exporter tout (avec détails)">
                  <Button
                    variant="contained"
                    color="info"
                    startIcon={<DownloadIcon />}
                    onClick={exportAllWithDetailsToExcel}
                    size="small"
                    disabled={sortedData.length === 0}
                  >
                    Export complet
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <TableContainer sx={{ maxHeight: 500 }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell 
                        sx={{ 
                          fontWeight: 'bold',
                          cursor: 'pointer',
                          backgroundColor: '#f5f5f5',
                          '&:hover': { backgroundColor: '#e3f2fd' }
                        }}
                        onClick={() => handleSort('libelle_fr')}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          Activités
                          {sortConfig.key === 'libelle_fr' && (
                            sortConfig.direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell 
                        align="center" 
                        sx={{ 
                          fontWeight: 'bold', 
                          width: '180px',
                          cursor: 'pointer',
                          backgroundColor: '#f5f5f5',
                          '&:hover': { backgroundColor: '#e3f2fd' }
                        }}
                        onClick={() => handleSort('missions')}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Nombre de missions
                          {sortConfig.key === 'missions' && (
                            sortConfig.direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold', width: '150px', backgroundColor: '#f5f5f5' }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((row, index) => (
                        <TableRow 
                          hover 
                          key={index}
                          sx={{
                            '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                            '&:hover': { backgroundColor: '#e3f2fd' }
                          }}
                        >
                          <TableCell>
                            <Typography 
                              variant="body2" 
                              sx={{
                                maxWidth: '500px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                              title={row.libelle_fr || row.libelle || row.nom}
                            >
                              {row.libelle_fr || row.libelle || row.nom}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Chip 
                              label={row.missions}
                              color={row.missions > 0 ? "primary" : "default"}
                              size="small"
                              variant={row.missions > 0 ? "filled" : "outlined"}
                              className={classes.clickableChip}
                              onClick={() => handleViewDetails(row)}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<VisibilityIcon />}
                                onClick={() => handleViewDetails(row)}
                                sx={{
                                  backgroundColor: '#1976d2',
                                  '&:hover': { backgroundColor: '#1565c0' },
                                  textTransform: 'none',
                                  borderRadius: '20px',
                                  fontSize: '0.75rem'
                                }}
                              >
                                Voir
                              </Button>
                              {row.details && row.details.length > 0 && (
                                <Tooltip title="Exporter les détails">
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={() => exportDetailsToExcel(row)}
                                    sx={{
                                      backgroundColor: '#e8f5e8',
                                      '&:hover': { backgroundColor: '#c8e6c9' }
                                    }}
                                  >
                                    <FileDownloadIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                          <Typography variant="body1" color="textSecondary">
                            Aucune donnée disponible. Veuillez effectuer une recherche.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              
              {sortedData.length > 0 && (
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  component="div"
                  count={sortedData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Lignes par page:"
                  labelDisplayedRows={({ from, to, count }) => 
                    `${from}-${to} sur ${count}`
                  }
                  showFirstButton
                  showLastButton
                  sx={{
                    borderTop: '1px solid rgba(224, 224, 224, 1)',
                    '& .MuiTablePagination-select': {
                      borderRadius: '4px',
                    }
                  }}
                />
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* Modal de détails */}
        <Dialog 
          open={openDialog} 
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ 
            backgroundColor: '#1976d2', 
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography variant="h6">Détails de l'activité</Typography>
            <Box>
              {selectedRow && selectedRow.details && selectedRow.details.length > 0 && (
                <Tooltip title="Exporter les détails en Excel">
                  <IconButton
                    onClick={() => exportDetailsToExcel(selectedRow)}
                    sx={{ color: 'white', mr: 1 }}
                    size="small"
                  >
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
              )}
              <Button 
                onClick={handleCloseDialog}
                sx={{ color: 'white', minWidth: 'auto' }}
              >
                ✕
              </Button>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            {selectedRow && (
              <Box sx={{ py: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Activité:</strong>
                </Typography>
                <Typography 
                  variant="body1" 
                  paragraph 
                  sx={{ 
                    bgcolor: '#f5f5f5', 
                    p: 2, 
                    borderRadius: 1,
                    wordBreak: 'break-word'
                  }}
                >
                  {selectedRow.libelle_fr || selectedRow.libelle || selectedRow.nom}
                </Typography>
                
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Nombre de missions:</strong>
                </Typography>
                <Chip 
                  label={selectedRow.missions}
                  color="primary"
                  sx={{ mb: 2 }}
                />
                
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Détails des missions:</strong>
                </Typography>
                <Box sx={{ bgcolor: '#fafafa', p: 2, borderRadius: 1 }}>
                  <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Référence</strong></TableCell>
                          <TableCell><strong>Titre de la mission</strong></TableCell>
                          <TableCell><strong>Date début</strong></TableCell>
                          <TableCell><strong>Date fin</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedRow.details && selectedRow.details.length > 0 ? (
                          selectedRow.details.map((detail, index) => (
                            <TableRow key={index} hover>
                              <TableCell>{detail.reference || '-'}</TableCell>
                              <TableCell sx={{ 
                                maxWidth: 300, 
                                whiteSpace: 'normal', 
                                wordBreak: 'break-word' 
                              }}>
                                {detail.mission_title || '-'}
                              </TableCell>
                              <TableCell>{detail.date_debut || '-'}</TableCell>
                              <TableCell>{detail.date_fin || '-'}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                              <Typography color="text.secondary">
                                Aucun détail disponible
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} variant="contained" color="primary">
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </MainContainer>
  );
}